import { Skeleton } from '@material-ui/lab';

const DummyText = ({ width }: { width?: number }) => (
  <Skeleton variant="text" data-testid="dummy-text" animation="wave" width={width ?? undefined} />
);

export default DummyText;
